import { Component, OnInit, ElementRef, Inject, Input} from '@angular/core';
import {DOCUMENT} from '@angular/common'
import { tap } from 'rxjs/operators';
import { CategoriesApiService, categoryRaw } from "../../api/categories-api.service";
import { JarvisApiService, personData } from "../../api/jarvis-api.service";
import { cliente, PcrcApiService } from "../../api/pcrc-api.service";
import { StateService } from "../../services/state.service";
import { Article } from '../../article';
import { ReportsApiService } from "../../api/reports-api.service";
import { posibleFilterFields, commentsReport } from "../../api/reports-api.service";
import format from 'date-fns/format';
import {ExportExcelService} from 'src/app/api/export-excel.service';
import * as XLSX from 'xlsx'
import Swal from 'sweetalert2'
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-reporte-lectura',
  templateUrl: './reporte-lectura.component.html',
  styleUrls: ['./reporte-lectura.component.css']
})
export class ReporteLecturaComponent implements OnInit {


  public initialDateDrop = false
  public finalDateDrop = false
  
  public categoryDrop = false
  public articlesDrop = false

  public isDirectorActive = false
  public isGerenteActive = false
  public isCoordinadorActive = false
  public isLiderActive = false
  public isPcrcActive = false
  public isCategoriaActive = false
  public isArticleActive = false  

  clientesList: cliente[]
  pcrcList: cliente['pcrcs'][0][]
  categoriesList: {
    state: "finish" | "loading";
    value?: categoryRaw[];
  }
  
  directores: personData[]
  gerentesList: personData[]
  coordisList: personData[]
  lideresList: personData[]

  selectedCliente: cliente
  selectedPcrc: cliente['pcrcs'][0]
  selectedCategory: categoryRaw
  selectedArticle: Article

  selectedDirector: personData
  selectedGerente: personData
  selectedCoordi: personData
  selectedLider: personData

  initialDate:Date
  finalDate:Date
  initialDateHumanRead = ''
  finalDateHumanRead = ''
  initialDateParam=''
  finalDateParam=''
  date=''

  data:any;
  dataLimit:any;
  verificar:boolean;
  currentPage = 1;
  pageSize = 12;
  totalItems:number = 0;
  tableIsLoading = false;
  textCliente=""
  textPcrc=""
  page = 1
  selectedData: commentsReport['items'][0];
  loading = false
  cargando = false
  expo= false

  constructor(
    @Inject(DOCUMENT) document,
    public state: StateService,
    public pcrcApi: PcrcApiService,
    public jarvisApi: JarvisApiService,
    public categoriesApi: CategoriesApiService,
    public reportsApi: ReportsApiService,
    public excelservice:ExportExcelService,
    public elem: ElementRef,
    public router:Router,
    private translate: TranslateService
   
  ) { }
  
  ngOnInit() {
   
    this.cargando= true
    this.pcrcApi.getUserPcrc(this.state.getValueOf('user').sub, 0, 1000).pipe(
      tap(pcrcs => {
        this.clientesList = [ { cliente:'Cualquiera', id_dp_clientes:0, pcrcs:[] } ,...pcrcs]
      
        this.cargando= false
      })
    ).subscribe()

   /*  this.jarvisApi.getClientDirectores('all').pipe(
      tap(directores => {
        this.directores = [{ cedula: '0', nombre: 'Cualquiera' }, ...directores]
      })
    ).subscribe() */

    this.verificar=false;
   
 
  }

  getTexto(event){
    this.textCliente = event
  }

  getPcrc(event){
    this.textPcrc = event
  }
  
  clienteSelected(selectedClient: any) {
   
  
   
    this.selectedCliente = selectedClient

    this.isPcrcActive = true

    this.pcrcList = [ { cod_pcrc:'0', id_dp_pcrc:0, pcrc:'Cualquiera' } , ...selectedClient.pcrcs ]
  
    this.categoriesList = null
 
    this.selectedCategory = null

    this.selectedPcrc = null

  }

  pcrcSelected(event: cliente['pcrcs'][0]) {
   /*  const boton = <HTMLInputElement> document.getElementById('button')
    boton.disabled= false */

    this.selectedPcrc = event

    this.selectedCategory = null

    this.categoriesApi.getCategories(this.selectedPcrc.id_dp_pcrc.toString()).pipe(
      tap(categories => {
        if(categories.state == 'finish'){
          this.categoriesList = { state:'finish', value:[ {
            icon:'',
            id:'',
            name:'Cualquiera',
            parent_id:'',
            base_id:'',
            position:0
          }, ...categories.value] }

        } else {
          this.categoriesList = categories

        }

        this.isCategoriaActive = true;
      })
    ).subscribe()

  }

  categorySelected(event: categoryRaw) {

    this.selectedCategory = event

    this.isArticleActive = true

  }

  articleSelected(event: Article) {
    this.articlesDrop = false
    this.selectedArticle = event
  }

  onInitialDateChange(event: { value: Date }) {
    this.initialDate = event.value
    this.initialDate.setHours(0)
    this.initialDate.setMinutes(0)
    this.initialDateHumanRead = format(this.initialDate, "dd/MM/y")
    this.initialDateParam = format(this.initialDate, "y-MM-dd")
  }

  onFinalDateChange(event: { value: Date }) {
    this.finalDate = event.value
    this.finalDate.setHours(23)
    this.finalDate.setMinutes(59)
    this.finalDateHumanRead = format(this.finalDate, "dd/MM/y")
    this.finalDateParam = format(this.finalDate, "y-MM-dd")
    this.date=(this.finalDate.getFullYear()+"/"+(this.finalDate.getMonth()+1)+"/"+(this.finalDate.getDate()+1))
   
  }  

  /* onDirectorSelected(directorSelected: personData) {

    console.log(directorSelected)

    this.selectedDirector = directorSelected;

    this.jarvisApi.getDirectorGerentes(directorSelected.cedula).pipe(
      tap(gerentes => {
        this.gerentesList = [{ cedula: '0', nombre: 'Cualquiera' }, ...gerentes]
        this.isGerenteActive = true;
      })
    ).subscribe()

  }

  onGerenteSelected(gerenteSelected: personData) {
    this.selectedGerente = gerenteSelected

    this.jarvisApi.getGerenteCoordis(gerenteSelected.cedula).pipe(
      tap(coordis => {
        this.coordisList = [{ cedula: '0', nombre: 'Cualquiera' }, ...coordis];
        this.isCoordinadorActive = true;
      })
    ).subscribe()
  }

  onCoordiSelected(coordiSelected: personData) {
    this.selectedCoordi = coordiSelected

    this.jarvisApi.getCoordiLideres(coordiSelected.cedula).pipe(
      tap(lideres => {
        this.isLiderActive = true
        this.lideresList = [{ cedula: '0', nombre: 'Cualquiera' }, ...lideres]
      })
    ).subscribe()
  }

  onLiderSelected(selectedLider: personData) {
    this.selectedLider = selectedLider
  } */

  search() {

    this.getFilters();
  
  }

  getverify(data){

    if((([].concat.apply({}, data).length)-1)===0){
      this.verificar=false;
   }else{
     this.verificar=true;
   }
  }

  limpiar()
    {
      this.router.navigate(['/app/redirect/lecturabilidad'])
    }

  getFilters() {

    if(this.initialDateParam=="" || this.finalDateParam=="" ){
      return Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: this.translate.instant('LLenar campos de fecha')
      })
     }
   if(!this.textCliente){
    return Swal.fire({
      icon: 'error',
      title: 'Oops...',
      text: this.translate.instant('Selecciona el cliente')
    })
   }

   if(!this.textPcrc){
    return Swal.fire({
      icon: 'error',
      title: 'Oops...',
      text: this.translate.instant('Selecciona el pcrc')
    })
   }

   this.elem.nativeElement.querySelector('table').classList.add('show')
   this.elem.nativeElement.querySelector('.btn-primary').classList.add('show')
   this.elem.nativeElement.querySelector('.btn-primary2').classList.add('show')

    this.tableIsLoading=true
    this.loading= true 
    let filter1: { filter: posibleFilterFields, value: string }

    let filter2: { filter: posibleFilterFields, value: string }

    if (!!this.selectedCliente && this.selectedCliente.cliente != 'Cualquiera') {

      filter1 = { value: this.selectedCliente.id_dp_clientes.toString(), filter: 'cliente' }

      if (!!this.selectedPcrc && this.selectedPcrc.pcrc != 'Cualquiera') {

        filter1 = { value: this.selectedPcrc.id_dp_pcrc.toString(), filter: 'pcrc' }
      
       
         if(this.selectedCategory==null){
          this.reportsApi.getLectura(this.initialDateParam,this.finalDateParam,this.selectedPcrc.id_dp_pcrc).subscribe(
            data=> {
              this.data=data,
              this.getverify(data),
              this.tableIsLoading=false
              this.loading= false
            },
            err=>console.log(err)
          )
          this.reportsApi.getLecturaLimit(this.initialDateParam,this.finalDateParam,this.selectedPcrc.id_dp_pcrc, this.page).subscribe(
            data =>{
               this.dataLimit= data
               this.tableIsLoading=false
               this.loading= false
             
               this.getverify(data)
            },err=>console.log(err)
          )
          
         }
       
        if (!!this.selectedCategory && this.selectedCategory.name != 'Cualquiera') {
           filter1 = { value: this.selectedCategory.id, filter: 'categoria' }
              this.reportsApi.getLecturaCategory(this.initialDateParam,this.finalDateParam,this.selectedCategory.id).subscribe(
                data=> {
               
                  this.data=data,
                  this.getverify(data),
                  this.tableIsLoading=false
                  this.loading= false
                },
                err=>console.log(err)
               )

               this.reportsApi.getLecturacategoryLimit(this.initialDateParam,this.finalDateParam,this.selectedCategory.id, this.page).subscribe(
                data=> {
               
                  this.dataLimit=data,
                  this.getverify(data),
                  this.tableIsLoading=false
                  this.loading= false
                },
                err=>console.log(err)
               )


         /* if (!!this.selectedArticle && this.selectedArticle.title != 'Cualquiera') {

            filter1 = { value: this.selectedArticle.id, filter: 'articulo' }
            console.log( this.selectedArticle.id)
          
             
         } */
        }
      }
    }
/*
    if (!!this.selectedDirector && this.selectedDirector.cedula != '0') {
      filter2 = { filter: 'director', value: this.selectedDirector.cedula }
      if (!!this.selectedGerente && this.selectedGerente.cedula != '0') {
        filter2 = { filter: 'gerente', value: this.selectedGerente.cedula }
        if (!!this.selectedCoordi && this.selectedCoordi.cedula != '0') {
          filter2 = { filter: 'coordinador', value: this.selectedCoordi.cedula }
          if (!!this.selectedLider && this.selectedLider.cedula != '0') {
            filter2 = { filter: 'lider', value: this.selectedLider.cedula }
          }
        }
      }
    }
     console.log(this.selectedArticle,this.selectedCategory,this.selectedCliente,this.selectedCoordi,
      this.selectedData,this.selectedDirector,this.selectedGerente,this.selectedLider,this.selectedPcrc)
    return [ filter1, filter2].filter(f => f) */
  }

  preview(){
    this.page--
   if(this.selectedCategory== null){
    if(this.page==1){
      return
      } else {
        this.reportsApi.getLecturaLimit(this.initialDateParam,this.finalDateParam,this.selectedPcrc.id_dp_pcrc, this.page).subscribe(
          data =>{
            this.dataLimit= data
            this.tableIsLoading=false
          
          },err=>console.log(err)
        )
      }
       
      }


      if(this.page ==1){
        return
      }else{
        this.reportsApi.getLecturacategoryLimit(this.initialDateParam,this.finalDateParam,this.selectedCategory.id, this.page).subscribe(
          data=> {
            this.dataLimit=data,
            this.getverify(data),
            this.tableIsLoading=false
            
          },
          err=>console.log(err)
         )
      }
     

 }

 next(){
  this.page++
    if(this.selectedCategory==null){
      this.reportsApi.getLecturaLimit(this.initialDateParam,this.finalDateParam,this.selectedPcrc.id_dp_pcrc, this.page).subscribe(
        data =>{
          this.dataLimit= data
          this.tableIsLoading=false
    
        },err=>console.log(err)
      )
    }

    this.reportsApi.getLecturacategoryLimit(this.initialDateParam,this.finalDateParam,this.selectedCategory.id, this.page).subscribe(
      data=> {
        this.dataLimit=data,
        this.getverify(data),
        this.tableIsLoading=false
        
      },
      err=>console.log(err)
     )

  
 }

    exportExcel(){
      this.expo = true
      let result = this.data.map((item)=>{
          if(item.permanencia.slice(-2)>=10){
            item.permanencia = "SI"
            return item
          }else {
            item.permanencia = "NO"
            return item
          }
      })
 
       const ws :XLSX.WorkSheet = XLSX.utils.json_to_sheet(result)
  
       const wb: XLSX.WorkBook = XLSX.utils.book_new()

       XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
 
       XLSX.writeFile(wb, 'ExcelSheet.xlsx');
      
       this.expo= false
    
    }


 /*  pageSelected(event){
    this.currentPage = event
    this.search()
  }

  rowSelected(event:{data:commentsReport['items'][0]}){
    this.selectedData = event.data
  } */

}
